import {AfterViewChecked, AfterViewInit, Component, Input, ViewChild} from "@angular/core";
import {CodeTableEnum} from "../../../../shared/model/code";
import {CurrentOrRealizedInvestmentRecord} from "../../../models/current-or-realized-investment-record";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";

@Component({
    selector: "valumize-fund-current-and-realized-investments",
    templateUrl: "./fund-current-and-realized-investments.component.html",
    styleUrls: ["./fund-current-and-realized-investments.component.scss"],
    standalone: false
})
export class FundCurrentAndRealizedInvestmentsComponent implements AfterViewInit, AfterViewChecked {
    @Input() fundId?: number;
    @Input() fundReportId?: number;
    @Input() fundValuationId?: number;
    @Input() columnDefinition: string[] = [];
    @Input() title?: string;

    @Input() set dataSource(records: CurrentOrRealizedInvestmentRecord[]) {
        this.tableDataSource.data = records;
    }

    tableDataSource = new MatTableDataSource<CurrentOrRealizedInvestmentRecord>();

    @ViewChild(MatSort, { static: false }) sort!: MatSort;
    @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

    codeTableCountry = CodeTableEnum.SHARED_COUNTRY;
    codeTableGpIndication = CodeTableEnum.ASSET_GPINDICATION;

    private isSortApplied = false;
    private isPaginatorApplied = false;

    ngAfterViewInit(): void {
        this.applySort();
        this.applyPaginator();
    }

    ngAfterViewChecked(): void {
        if (!this.isSortApplied && this.sort) {
            this.applySort();
        }
        if (!this.isPaginatorApplied && this.paginator) {
            this.applyPaginator();
        }
    }

    private applySort(): void {
        if (this.sort) {
            if (!this.isSortApplied) {
                this.tableDataSource.sort = this.sort;

                this.tableDataSource.sortingDataAccessor = (item, property) => {
                    switch (property) {
                        case "company":
                            return item.company?.text?.toLowerCase() ?? "";
                        case "activityIndustry":
                            return item.activityIndustry?.text?.toLowerCase() ?? "";
                        case "country":
                            return item.country?.code?.toLowerCase() ?? "";
                        case "gpIndication":
                            return item.gpIndication?.code?.toLowerCase() ?? "";
                        case "investmentDate":
                            return item.investmentDate?.date ? new Date(item.investmentDate.date).getTime() : 0;
                        case "effectiveExitDate":
                            return item.effectiveExitDate?.date ? new Date(item.effectiveExitDate.date).getTime() : 0;
                        case "percentageHeld":
                            return item.percentageHeld?.fraction ?? 0;
                        case "holdingPeriodInYears":
                            return item.holdingPeriodInYears ?? 0;
                        case "realizedCost":
                            return item.realizedCost?.amount ?? 0;
                        case "realizedGains":
                            return item.realizedGains?.amount ?? 0;
                        case "totalCost":
                            return item.totalCost?.amount ?? 0;
                        case "totalRealized":
                            return item.totalRealized?.amount ?? 0;
                        default:
                            return "";
                    }
                };
                this.isSortApplied = true;
            }
        }
    }

    private applyPaginator(): void {
        if (this.paginator) {
            this.tableDataSource.paginator = this.paginator;
            this.isPaginatorApplied = true;
        }
    }
}
